(function () {
  if (window.__customLocalizationSwitcherInitialized) return;
  window.__customLocalizationSwitcherInitialized = true;

  const scriptTag = document.querySelector(
    "script[data-custom-localization-switcher]",
  );
  const mappingInlineId = scriptTag
    ? scriptTag.getAttribute("data-mapping-inline-id")
    : null;
  const fallbackLocale =
    (scriptTag && scriptTag.getAttribute("data-fallback-locale")) || "en";
  let mapPromise;

  function parseJsonSafely(rawJson) {
    if (!rawJson) return null;

    try {
      return JSON.parse(rawJson);
    } catch (error) {
      return null;
    }
  }

  function normalizeIsoToLocaleMap(data) {
    if (!data) return {};

    if (typeof data === "string") {
      const parsed = parseJsonSafely(data);
      if (!parsed) return {};
      return normalizeIsoToLocaleMap(parsed);
    }

    if (typeof data !== "object") {
      return {};
    }

    if (
      data.countryToLanguageMap &&
      typeof data.countryToLanguageMap === "object"
    ) {
      const flatMap = {};

      Object.keys(data.countryToLanguageMap).forEach(function (countryName) {
        const entry = data.countryToLanguageMap[countryName] || {};
        if (!entry.country_code || !entry.locale_code) return;

        flatMap[String(entry.country_code).toUpperCase()] = String(
          entry.locale_code,
        ).toLowerCase();
      });

      return flatMap;
    }

    const normalized = {};

    Object.keys(data).forEach(function (key) {
      const value = data[key];
      if (value == null || value === "") return;
      normalized[String(key).toUpperCase()] = String(value).toLowerCase();
    });

    return normalized;
  }

  function getInlineIsoToLocaleMap() {
    if (!mappingInlineId) return null;

    const inlineNode = document.getElementById(mappingInlineId);
    if (!inlineNode) return null;

    const parsedInlineData = parseJsonSafely(
      (inlineNode.textContent || "").trim(),
    );
    if (parsedInlineData == null) {
      console.warn("Could not parse inline country-language mapping");
      return null;
    }

    return normalizeIsoToLocaleMap(parsedInlineData);
  }

  function getIsoToLocaleMap() {
    if (mapPromise) return mapPromise;

    const inlineMap = getInlineIsoToLocaleMap();
    if (inlineMap) {
      mapPromise = Promise.resolve(inlineMap);
      return mapPromise;
    }

    console.warn(
      "Inline country-language mapping is missing or invalid; using fallback locale only.",
    );

    mapPromise = Promise.resolve({});

    return mapPromise;
  }

  function ensureHiddenInput(form, selector, name, className) {
    let input = form.querySelector(selector);

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.className = className;
      form.appendChild(input);
    }

    return input;
  }

  function getRoot(button) {
    return button.closest(
      '[data-custom-country-selector="true"], [data-localization-switch-root="true"]',
    );
  }

  function resolveForm(button) {
    const formByClosest = button.closest("form");
    if (formByClosest) return formByClosest;

    const root = getRoot(button);
    if (!root) return null;

    const formId = root.getAttribute("data-form-id");
    if (formId) {
      const formById = document.getElementById(formId);
      if (formById) return formById;
    }

    return root.querySelector("form");
  }

  function findAnyLocalizationForm() {
    const localeInput = document.querySelector("input.hidden-locale-input");
    return localeInput ? localeInput.closest("form") : null;
  }

  function submitForm(form, button) {
    if (typeof form.requestSubmit === "function") {
      if (button && button.form === form) {
        form.requestSubmit(button);
      } else {
        form.requestSubmit();
      }
      return;
    }

    const submitEvent = new Event("submit", {
      bubbles: true,
      cancelable: true,
    });

    if (form.dispatchEvent(submitEvent)) {
      form.submit();
    }
  }

  async function submitLocalization(button, form) {
    if (!form) return;

    const usingFallback = button.closest("form") !== form;

    const countryIso = (
      button.getAttribute("data-country-iso") ||
      button.value ||
      ""
    ).toUpperCase();
    if (!countryIso) return;

    const inlineTargetLocale = (
      button.getAttribute("data-target-locale") || ""
    ).toLowerCase();
    const isoToLocaleMap = await getIsoToLocaleMap();
    const nextLocale =
      inlineTargetLocale || isoToLocaleMap[countryIso] || fallbackLocale;

    const countryInput = ensureHiddenInput(
      form,
      ".auto-country-hidden",
      "country_code",
      "auto-country-hidden",
    );
    countryInput.value = countryIso;

    const localeInput = ensureHiddenInput(
      form,
      ".hidden-locale-input",
      "locale_code",
      "hidden-locale-input",
    );
    localeInput.value = nextLocale;

    if (usingFallback) {
      const returnTo = nextLocale === "it" ? "/" : "/" + nextLocale;
      const allReturnToInputs = Array.from(
        form.querySelectorAll('input[name="return_to"]'),
      );
      if (allReturnToInputs.length > 0) {
        allReturnToInputs.forEach(function (input) {
          input.value = returnTo;
        });
      } else {
        ensureHiddenInput(
          form,
          ".auto-return-to-hidden",
          "return_to",
          "auto-return-to-hidden",
        ).value = returnTo;
      }
    }

    submitForm(form, usingFallback ? null : button);
  }

  function getButtonFromEvent(event) {
    if (event.target instanceof Element) {
      const direct = event.target.closest(
        ".custom-country-button[data-country-iso]",
      );
      if (direct) return direct;
    }

    if (typeof event.composedPath === "function") {
      const path = event.composedPath();
      for (const node of path) {
        if (
          node instanceof Element &&
          node.matches(".custom-country-button[data-country-iso]")
        ) {
          return node;
        }
      }
    }

    return null;
  }

  function cleanupCountryParam() {
    if (!window.location.search) return;
    const params = new URLSearchParams(window.location.search);
    if (!params.has("country")) return;
    params.delete("country");
    const newSearch = params.toString();
    const newUrl =
      window.location.pathname +
      (newSearch ? "?" + newSearch : "") +
      window.location.hash;
    window.history.replaceState(null, "", newUrl);
  }

  cleanupCountryParam();

  document.addEventListener(
    "click",
    function (event) {
      const button = getButtonFromEvent(event);
      if (!button) return;

      const form = resolveForm(button) || findAnyLocalizationForm();
      if (!form) return;

      event.preventDefault();
      submitLocalization(button, form);
    },
    true,
  );
})();
